import React from "react";
import { Image } from "react-bootstrap";
import Icons from "../assets/Icons";
import { getDateLocale, getDetailLink, getItemPrimaryImage } from "../utils/utilFunction";
const ReleatedCard = ({item , loading}) => {
  if (loading) {
    return (
      <div className="box box--skeleton" aria-hidden="true">
        <div className="relatedSkeletonImage" />
        <div className="text">
          <div className="relatedSkeletonLine relatedSkeletonLine--title" />
          <div className="relatedSkeletonLine relatedSkeletonLine--description" />
          <div className="relatedSkeletonLine relatedSkeletonLine--abstract" />
          <div className="relatedSkeletonLine relatedSkeletonLine--date" />
        </div>
      </div>
    );
  }

  return (
   <div className="box">
      <a href={getDetailLink(item)}>
        <div className="image">
          <Image alt={item.title} src={getItemPrimaryImage(item.primaryImage)} />
        </div>
        <div className="text">
          <div className="description">{item.definition}</div>
          <div className="title">{item.title}</div>
          <div className="abstract">{item.relationName}</div>
          <div className="icons">
            <span 
              dangerouslySetInnerHTML={{ __html: Icons.calendar }}
              className="_icon"
            />
            <span> {getDateLocale(item.releaseDate)}</span>
          </div>
        </div>
      </a>
    </div>
  );
};

export default ReleatedCard;
